import { Box, Chip, Stack, Typography } from "@compass/core";
import { Logo } from "components";
import { authColors } from "../styles/authStyles";

export const BrandingHeader = () => (
  <Stack alignItems="center" spacing="sm">
    <Box>
      <Logo width="80px" animate={true} />
    </Box>
    <Box
      sx={{
        width: "60px",
        height: "2px",
        bgcolor: authColors.border.default,
        borderRadius: "1px",
      }}
    />
    <Typography
      sx={{
        color: authColors.text.primary,
        fontWeight: 700,
        fontSize: "1.75rem",
        letterSpacing: "0.35em",
        textTransform: "uppercase",
      }}
    >
      Compass
    </Typography>
  </Stack>
);